import { render, staticRenderFns } from "./FudouDetailComponent.vue?vue&type=template&id=c83c9cda&scoped=true"
import script from "./FudouDetailComponent.vue?vue&type=script&lang=js"
export * from "./FudouDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./FudouDetailComponent.vue?vue&type=style&index=0&id=c83c9cda&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83c9cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c83c9cda')) {
      api.createRecord('c83c9cda', component.options)
    } else {
      api.reload('c83c9cda', component.options)
    }
    module.hot.accept("./FudouDetailComponent.vue?vue&type=template&id=c83c9cda&scoped=true", function () {
      api.rerender('c83c9cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/fuCard/FudouDetailComponent.vue"
export default component.exports